import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error('404: non-existent route:', location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-muted">
      <div className="text-center">
        <h1 className="mb-2 text-6xl font-bold text-ink">404</h1>
        <p className="mb-2 text-xl font-medium text-ink">Page not found</p>
        <p className="mb-6 text-sm text-ink-muted">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <button
          type="button"
          onClick={() => navigate('/calendar', { replace: true })}
          className="rounded-xl bg-brand px-5 py-2.5 text-sm font-semibold text-brand-foreground shadow-sm transition hover:opacity-95"
        >
          Return to calendar
        </button>
      </div>
    </div>
  );
};

export default NotFound;
